



















































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ListViewItem from 'list-view/src/listviewitem';
import NewsModel from '@views/a-model/news-model';
import DefaultModel from '@views/a-model/default-model';
import EnumNewsType from '../../dataSource/api/RunPay/DataModels/Enums/EnumNewsType';
import ControlValidatorGroupComponent from '../components/control-validator-group.vue';
import TaskModelSimple from '../a-model/taskModelSimple';
import iOrganization from '../a-model/interfaces/iOrganization';

@Component({
  name: 'contracts',
  components: {},
})
export default class ContractsComponent extends Vue {
  innerItems: iOrganization[] = [];
  hoverApproved = false;
  pageSize = 6;
  currentPage = 1;
  totalItems = 0;

  modalWindowTitle = '';
  modalWindowShow = false;

  currentEditItemId = 0;

  search = '';
  notIsApproved = false;
  created() {
    document.title = this.$route.meta.title;

    this.getItems({ Take: this.pageSize, Skip: 0 });
  }

  isValid(): boolean {
    // if (
    //   this.fileZip == null &&
    //   !this.addingNews === undefined &&
    //   !this.addingNews.folderName.startsWith("http")
    // ) {
    //   this.zipAlert = true;
    // }

    // if (this.file == null) {
    //   this.imageAlert = true;
    // } else this.imageAlert = false;
    return (this.$refs.validator as ControlValidatorGroupComponent).isValid();
  }
  onhover() {
    // console.log("dd");
    this.hoverApproved = true;
  }
  getItems({ Skip, Take }: { Skip: number; Take: number }) {
    this.$api.ContractService.GetPaginatedContractsListEvent.once((response) => {
      if (!response.IsSuccess) {
        return;
      }
      this.innerItems = [];
      this.totalItems = response.Value.Count;
      this.innerItems = response.Value.Items.map((item) => ({
        id: item.Id.toString(),
        name: item.EnterpriseName != null ? item.EnterpriseName.toString() : '',
        inn: item.INN != null ? item.INN.toString() : '',
        address: item.Address != null ? item.Address.toString() : '',
        phone: item.Phone != null ? item.Phone.toString() : '',
        email: item.Email != null ? item.Email.toString() : '',
        region: item.RegionId.toString(),
        typeContract: item.ContractType,
        countShop: item.ShopCount,
        countPoint: item.ItemCount,
        clientName: item.ClientName != null ? item.ClientName.toString() : '',
        pdfLink: item.DownloadUrl != null ? item.DownloadUrl.toString() : '',
        isApproved: item.IsApproved as boolean,
      }));
      // console.log(this.innerItems);
    });
    this.$api.ContractService.GetPaginatedContractsList({ Search: this.search, Skip: Skip, Take: Take });
  }

  onApproved(contarctId: number) {
    this.$api.ContractService.ApproveContractEvent.once((response) => {
      if (!response.IsSuccess) {
        this.$notification.error(response.ErrorMessage.toString());
        return;
      }
      this.getItems({ Take: this.pageSize, Skip: 0 });
    });
    var res = this.$dialog.confirm('Действительно подтвердить регистрацию контракта?').then((res: boolean) => {
      if (res) {
        this.$api.ContractService.ApproveContract(contarctId);
      }
      if (res == false) {
      }
    });
  }
  onOpenPdf(link: string) {
    window.open(link);
  }

  onEditf(id: string) {}

  onSearch() {
    this.getItems({ Take: this.pageSize, Skip: 0 });
  }

  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.currentPage = request.Page;
    this.getItems({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage,
    });
  }

  onDonloadZip() {
    (this.$refs.fileInputZip as any).click();
  }
  onDonload() {
    (this.$refs.fileInput as any).click();
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-contracts.vue